// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-tabs_size_l {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
}
.dl-tabs_size_xl {
  font-family: var(--g-text-subheader-font-family);
  font-weight: var(--g-text-subheader-font-weight);
  font-size: var(--g-text-subheader-3-font-size);
  line-height: var(--g-text-subheader-3-line-height);
}
.dl-tabs .gc-adaptive-tabs {
  overflow: hidden;
  font-weight: 400;
}
.dl-tabs .gc-adaptive-tabs__tab {
  padding: 0;
}
.dl-tabs .gc-adaptive-tabs__tab-container {
  margin: 0;
  line-height: 0;
}
.dl-tabs .gc-adaptive-tabs__tab-container_switcher-tab {
  height: var(--gc-tabs-height);
  padding: var(--gc-tabs-border-width) 1px 0;
}
.dl-tabs__tab {
  width: 100%;
  min-width: 40px;
  display: inline-block;
  border-bottom: var(--gc-tabs-border-width) solid transparent;
  height: calc(var(--gc-tabs-height) - 2px);
  padding: var(--gc-tabs-border-width) 1px 0;
  box-sizing: content-box;
  overflow: hidden;
}
.dl-tabs__tab_active {
  border-bottom-color: var(--gc-tabs-color-border-active);
  color: var(--gc-tabs-color-text-active);
}
.dl-tabs_opacity .dl-tabs__tab:not(.dl-tabs__tab_active) {
  opacity: 0.7;
}
.dl-tabs_opacity:not(.dl-tabs_mobile) .dl-tabs__tab:not(.dl-tabs__tab_active):hover, .dl-tabs_opacity:not(.dl-tabs_mobile) .dl-tabs__tab:not(.dl-tabs__tab_active):focus {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Tabs/Tabs.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAUI;ECoKA,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;AD5KJ;AASI;EC+NA,gDAAA;EACA,gDAAA;EACA,8CAAA;EACA,kDAAA;ADrOJ;AAOI;EACI,gBAAA;EACA,gBAAA;AALR;AAOQ;EACI,UAAA;AALZ;AAQQ;EACI,SAAA;EACA,cAAA;AANZ;AAQY;EACI,6BAAA;EACA,0CAAA;AANhB;AAWI;EACI,WAAA;EAIA,eAAA;EAEA,qBAAA;EACA,4DAAA;EACA,yCAAA;EACA,0CAAA;EACA,uBAAA;EACA,gBAAA;AAbR;AAeQ;EACI,uDAAA;EACA,uCAAA;AAbZ;AAkBQ;EACI,YAAA;AAhBZ;AAsBY;EAEI,UAAA;AArBhB","sourcesContent":[".dl-tabs_size_l {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n}\n.dl-tabs_size_xl {\n  font-family: var(--g-text-subheader-font-family);\n  font-weight: var(--g-text-subheader-font-weight);\n  font-size: var(--g-text-subheader-3-font-size);\n  line-height: var(--g-text-subheader-3-line-height);\n}\n.dl-tabs .gc-adaptive-tabs {\n  overflow: hidden;\n  font-weight: 400;\n}\n.dl-tabs .gc-adaptive-tabs__tab {\n  padding: 0;\n}\n.dl-tabs .gc-adaptive-tabs__tab-container {\n  margin: 0;\n  line-height: 0;\n}\n.dl-tabs .gc-adaptive-tabs__tab-container_switcher-tab {\n  height: var(--gc-tabs-height);\n  padding: var(--gc-tabs-border-width) 1px 0;\n}\n.dl-tabs__tab {\n  width: 100%;\n  min-width: 40px;\n  display: inline-block;\n  border-bottom: var(--gc-tabs-border-width) solid transparent;\n  height: calc(var(--gc-tabs-height) - 2px);\n  padding: var(--gc-tabs-border-width) 1px 0;\n  box-sizing: content-box;\n  overflow: hidden;\n}\n.dl-tabs__tab_active {\n  border-bottom-color: var(--gc-tabs-color-border-active);\n  color: var(--gc-tabs-color-text-active);\n}\n.dl-tabs_opacity .dl-tabs__tab:not(.dl-tabs__tab_active) {\n  opacity: 0.7;\n}\n.dl-tabs_opacity:not(.dl-tabs_mobile) .dl-tabs__tab:not(.dl-tabs__tab_active):hover, .dl-tabs_opacity:not(.dl-tabs_mobile) .dl-tabs__tab:not(.dl-tabs__tab_active):focus {\n  opacity: 1;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
